var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPriceDetails(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.625 2.625L13.5 1.5L12.375 2.625L11.25 1.5L10.125 2.625L9 1.5L7.875 2.625L6.75 1.5L5.625 2.625L4.5 1.5V12H2.25V14.25C2.25 15.495 3.255 16.5 4.5 16.5H13.5C14.745 16.5 15.75 15.495 15.75 14.25V1.5L14.625 2.625ZM14.25 14.25C14.25 14.6625 13.9125 15 13.5 15C13.0875 15 12.75 14.6625 12.75 14.25V12H6V3.75H14.25V14.25Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.25 5.25H6.75V6.75H11.25V5.25Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5001 5.25H12.0001V6.75H13.5001V5.25Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.25 7.5H6.75V9H11.25V7.5Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5001 7.5H12.0001V9H13.5001V7.5Z",
    fill: "black"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriceDetails);
export default __webpack_public_path__ + "static/media/PriceDetails.9716484f06dfd6fcae920cc287081543.svg";
export { ForwardRef as ReactComponent };